<template>
  <v-app id="v-app" class="w-full">
      <v-form
        ref="form"
        v-model="validForm"
        class="flex flex-wrap new-form">
        <div class="w-full lg:w-full lg:px-2">
        <v-text-field
                :label="trans[lang].name"
                color="white"
                v-model="name"
                :rules="formRules"
                filled
                rounded
                autocomplete="off"
            ></v-text-field>
        </div>
        <div class="w-full lg:w-1/2 lg:px-2">
        <v-text-field
                :label="trans[lang].phone"
                color="white"
                v-model="phone"
                :rules="phoneRules"
                filled
                rounded
                autocomplete="off"
            ></v-text-field>
        </div>
        <div class="w-full lg:w-1/2 lg:px-2">
            <v-text-field
                    label="Email*"
                    color="white"
                    v-model="email"
                    :rules="emailRules"
                    filled
                    rounded
                    autocomplete="off"
                ></v-text-field>
        </div>
        <div class="w-full lg:px-2">
             <v-select
                :label="trans[lang].selectSchool"
                color="white"
                v-model="select"
                :items="allSchools"
                item-text="title"
                :rules="selectRules"
                filled
                rounded
                autocomplete="off"
            ></v-select>
        </div>
        <div class="w-full lg:px-2">
        <v-textarea
                :label="trans[lang].message"
                color="white"
                v-model="text"
                :rules="messageRules"
                filled
                rounded
            ></v-textarea>
        </div>
            <!-- CheckboxPrivacy -->
            <div class="flex items-center mt-4 lg:mt-0 mb-2 privacy-container">
          <CheckboxVue
            id="privacy"
            :checked="checkboxChecked"
            @update:checked="checkboxChecked = $event"
            :error="checkboxError"
          >
            <p class="ml-4 text-white" :class="{ 'text-red': checkboxError }">
              {{ translations.steps[3].agreeTextPart1 }}
              <a class="topaz" :href="translations.steps[3].privacyPolicyLink" target="_blank">{{ translations.steps[3].privacyPolicyText }}</a>
              {{ translations.steps[3].agreeTextPart2 }}
              <a class="topaz" :href="translations.steps[3].termsLink" target="_blank">{{ translations.steps[3].termsText }}</a>
            </p>
          </CheckboxVue>
        </div>
        <div class="flex items-center mt-2 lg:mt-0 mb-8 privacy-container">
          <CheckboxVue
            id="privacy-commercial"
            :checked="checkboxCommercialChecked"
            @update:checked="checkboxCommercialChecked = $event"
          >
            <p class="ml-4 text-white">{{translations.steps[3].agree_commercial}}</p>
          </CheckboxVue>
        </div>
        <div class="flex justify-center">
            <v-btn
                type="submit"
                color="secundary"
                class="contactButton button-hover-dark"
                large
                :loading="loading"
                @click="validateAndSend"
                :disabled="disabledSubmit"
            >{{trans[lang].send_coment}}</v-btn>
        </div>
      </v-form>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarType"
            content-class="text-center"
            >
            {{ snackbarText }}
        </v-snackbar>
  </v-app>
</template>

<script>
import ProvinceSchoolComponent from './ProvinceSchoolComponent';
import {mapGetters, mapMutations} from 'vuex';
import CheckboxVue from './Checkbox.vue';

const trans = {
    ca: {
        name: 'Nom i cognoms*',
        phone: 'Telèfon mòbil*',
        selectSchool: 'Selecciona una autoescola*',
        message: 'En què et podem ajudar?',
        sent: 'Missatge enviat correctament!',
        close: 'Tancar',
        formRules: '* Nom obligatori',
        pleaseRecheck: 'Sisplau, comprova que hagis emplenat tots els camps correctament.',
        error: "S'ha produït un error. Sisplau, intenta-ho de nou.",
        send_coment: "Enviar comentari",
        phoneRules: [
            '* Telèfon obligatori',
            '* El telèfon ha de ser vàlid'
        ],
        emailRules: [
            '* Email obligatori',
            "* L'email ha de ser vàlid"
        ],
        messageRules: [
            '* Missatge obligatori',
            '* La longitud mínima del missatge és de 12 caràcters'
        ],
        selectRules: [
            '* Selecciona una autoescola',
        ]
    },
    es: {
        name: 'Nombre y apellidos*',
        phone: 'Teléfono móvil*',
        selectSchool: 'Selecciona una autoescuela*',
        message: '¿En qué podemos ayudarte?*',
        sent: 'Mensaje enviado correctamente!',
        close: 'Cerrar',
        formRules: '* Nombre obligatorio',
        pleaseRecheck: 'Por favor, comprueba que hayas rellenado todos los campos correctamente.',
        error: 'Se ha producido un error. Por favor, inténtalo de nuevo.',
        send_coment: "Enviar comentario",
        phoneRules: [
            '* Teléfono obligatorio',
            '* El teléfono debe ser válido'
        ],
        emailRules: [
            '* Email obligatorio',
            '* El email debe ser válido'
        ],
        messageRules: [
            '* Mensaje obligatorio',
            '* La longitud mínima del mensaje es de 12 caracteres'
        ],
         selectRules: [
            '* Selecciona una autoescuela',
        ]
    }
};

export default {
    components: {
        ProvinceSchoolComponent,
        CheckboxVue
    },
    data: () => ({
        loading: false,
        snackbar: false,
        snackbarType: '',
        snackbarText: '',
        formRules: [
            v => !!v || trans[window.appLocale].formRules
        ],
        phoneRules: [
            v => !!v || trans[window.appLocale].phoneRules[0],
            v=> /^\d{9}$/.test(v) || trans[window.appLocale].phoneRules[1],
        ],
        emailRules: [
            v => !!v || trans[window.appLocale].emailRules[0],
             v => /.+@.+\..+/.test(v) || trans[window.appLocale].emailRules[1],
        ],
        messageRules: [
             v => !!v || trans[window.appLocale].messageRules[0],
            v => (v || '').length >= 12 ||
                trans[window.appLocale].messageRules[1],
        ],
        selectRules: [
            v => !!v || trans[window.appLocale].selectRules[0],
        ],
        trans,
        checkboxChecked: false,
		translations: window.trans,
      	checkboxCommercialChecked: false,
        checkboxError: false
    }),
    computed: {
        ...mapGetters(['getFormData', 'provinces']),
        disabledSubmit(){
            return !this.validForm || !this.checkboxChecked
        },
        allSchools() {
            return this.provinces.flatMap(province => province.schools);
        },
        validForm: {
            get(){
                return this.$store.getters.validForm;
            },
            set(value){
                this.setValidForm(value);
            }
        },
        name: {
            get(){
                return this.$store.getters.getFormData.name;
            },
            set(payload){
                this.setParamFromFormData({
                    param: 'name',
                    value: payload
                })
            }
        },
        email: {
            get(){
                return this.$store.getters.getFormData.email;
            },
            set(payload){
                this.setParamFromFormData({
                    param: 'email',
                    value: payload
                })
            }
        },
        phone: {
            get(){
                return this.$store.getters.getFormData.phone;
            },
            set(payload){
                this.setParamFromFormData({
                    param: 'phone',
                    value: payload
                })
            }
        },
        text: {
            get(){
                return this.$store.getters.getFormData.text;
            },
            set(payload){
                this.setParamFromFormData({
                    param: 'text',
                    value: payload
                })
            }
        },
         select: {
            get(){
                return this.$store.getters.getFormData.school;
            },
            set(payload){
                this.setParamFromFormData({
                    param: 'school',
                    value: payload
                })
            }
        },
    },
    methods: {
        ...mapMutations(['setParamFromFormData','setValidForm']),
        validateAndSend(e){
            e.preventDefault();

            this.checkboxError = !this.checkboxChecked;

            if (!this.$refs.form.validate() || this.checkboxError) {
                this.showSnackbar('info', trans[this.lang].pleaseRecheck);
                return
            }



            this.loading = true;

            axios.post('/api/contact', {
                name: this.getFormData.name,
                phone: this.getFormData.phone,
                email: this.getFormData.email,
                message: this.getFormData.text,
                school: this.getFormData.school,
            }).then((res) => {
                console.log(res);
                this.loading= false;
                this.showSnackbar('success', trans[this.lang].sent);
                this.$refs.form.reset();
                this.checkboxChecked = false;
                this.checkboxCommercialChecked = false;
            }).catch(err => {
                console.log(err);
                this.loading = false;
                this.showSnackbar('info', trans[this.lang].error);
            });
        },
        showSnackbar(snackbarType, snackbarText) {
            this.snackbarType = snackbarType;
            this.snackbarText = snackbarText;
            this.snackbar = true;
        }
    },
    created() {
        this.lang = window.appLocale;
    }
}
</script>

<style lang="scss">
@import '../../sass/_variables.scss';

.new-form {
    .v-input{
        &__slot{
            background-color: transparent !important;
            border: solid 1px #9c96a0;

            label {
                color: #c9c9c9 !important;
                font-size: 14px;
            }
        }
    }
    .contactButton{
        font-size: 16px !important;
        font-stretch: 100%;
        background-color: $white !important;
        color: $dark !important;
        padding: 1.6rem 1.2rem !important;
        span {
            font-weight: bold;
            letter-spacing: 0;
            text-transform: none !important;
        }

        &.v-btn.v-btn--disabled{
            background-color: #c2c2c2 !important;
        }

    }
    input:-internal-autofill-selected {
        -webkit-appearance: menulist-button;
        background-color: transparent !important;
        background-image: none !important;
        color: -internal-light-dark-color(black, white) !important;
    }

}
</style>
